window.QuadTree = function (pLevel, x, y, width, height) {
	var MAX_OBJECTS = 5;
	var qtX = x, qtY = y, qtWidth = width, qtHeight = height;
	var level = pLevel;
	var nodes = [];
	var objects = [];

	function clear() {
		objects = [];
		for (var i = 0; i < nodes.length; i++) {
			nodes = [];
		}
	};

	// splits current quadrant
	function split() {
		var subWidth = qtWidth / 2.0;
		var subHeight = qtHeight / 2.0;
		nodes[0] = QuadTree(level + 1, qtX + subWidth, qtY, subWidth, subHeight);
		nodes[1] = QuadTree(level + 1, qtX, qtY, subWidth, subHeight);
		nodes[2] = QuadTree(level + 1, qtX, qtY + subHeight, subWidth, subHeight);
		nodes[3] = QuadTree(level + 1, qtX + subWidth, qtY + subHeight, subWidth, subHeight);
	}

	// returns index of the quadrant whithin which 'object' fits OR -1 if object cannot completely fit within a node
	function getIndex(object) {
		var index = -1; // -1 maens that object cannot completely fit within node
		var verticalMidpoint = qtX + qtWidth / 2.0;
		var horizontalMidpoint = qtY + qtHeight / 2.0;

		var topQuadrant = (object.y < horizontalMidpoint && object.y + object.height < horizontalMidpoint);
		var bottomQuadrant = (object.y > horizontalMidpoint);

		if (object.x < verticalMidpoint && object.x + object.width < verticalMidpoint) {
			if (topQuadrant) {
				index = 1;
			}
			else if (bottomQuadrant) {
				index = 2;
			}
		}
		else if (object.x > verticalMidpoint) {
			if (topQuadrant) {
				index = 0;
			}
			else if (bottomQuadrant) {
				index = 3;
			}
		}

		return index;
	}

	function insert(object) {
		if (nodes[0]) {
			// if object completely fits within a node, insert it into that node
			var index = getIndex(object);
			if (index != -1) {
				nodes[index].insert(object);
				return;
			}
		}

		objects.push(object);
		
		// if MAX_OBJECTS reached, try to move objects to underlying nodes
		if (objects.length > MAX_OBJECTS) {
			if (nodes[0] == null) {
				split();
			}
			for (var i = 0; i < objects.length; ) {
				var index = getIndex(objects[i]);
				if (index != -1 && objects.length > 1) {
					nodes[index].insert(objects[i]);
					objects.splice(i, 1);
				}
				else {
					i++;
				}
			}
		}
	};

	// returns all the objects which may collide with the 'object'
	function retrieve(object) {
		var returnObjects = [];

		if (nodes[0]) {
			var index = getIndex(object);
			if (index != -1) {
				returnObjects = nodes[index].retrieve(object);
			}
			else {
				for (var i = 0; i < 4; i++) {
					returnObjects = returnObjects.concat(nodes[i].retrieve(object));
				}
			}
		}

		returnObjects = returnObjects.concat(objects);

		return returnObjects;
	};

	return {
		insert: insert,
		retrieve: retrieve
	};
};